module.exports = __webpack_public_path__ + "img/en_compt.2b073bc0.svg";